module.exports = __webpack_public_path__ + "static/media/tuna-pizza.2a0a7737.png";